<template>
  <el-row class="filteringMain" style="text-align: left">
    <!-- <div class="mobileRow"> -->
    <span v-if="accType == 'SUPERADMIN'" class="formLabel">Selection</span>
    <el-select v-model="schoolSelection"
      v-if="['SUPERADMIN', 'COUNCIL_ADMIN', 'MULTI_SCHOOL_ADMIN'].indexOf(accType) > -1" multiple filterable
      collapse-tags clearable style="width: 28%; margin-right: 5px" placeholder="Filter by Schools"
      @change="updateSelection">
      <el-option-group v-for="group in filterGroups" :key="group.label" :label="group.label">
        <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-option-group>
    </el-select>
    <!-- <el-select
      v-model="schoolSelection"
      v-if="accType == 'COUNCIL_ADMIN'"
      multiple
      filterable
      collapse-tags
      style="width: 30%"
      placeholder="Select Schools"
      @change="returnSelection"
    >
      <el-option
        v-for="school in schools"
        :key="school.value"
        :label="school.label"
        :value="school.value"
      ></el-option>
    </el-select> -->
    <!-- </div> -->
    <el-date-picker v-if="showDatePicker" v-model="dateRange" type="datetimerange" range-separator="To"
      start-placeholder="Start date" end-placeholder="End date" :default-time="['08:00:00']"
      value-format="yyyy-MM-dd HH:mm" @change="returnSelection"></el-date-picker>
    <div style="width: 14%; display: inline-block; margin-right: 5px" class="mobileFullRow" v-if="showSchoolAddress">
      <span class="formLabel">Address</span>
      <el-select v-model="schoolAddressId" filterable collapse-tags placeholder="Select Address"
        @change="returnSelection" class="full">
        <el-option v-for="item in schoolAddresses" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <div v-if="showBaseline" style="width: 12%; display: inline-block; margin-right: 5px" class="mobileFullRow">
      <span class="formLabel">Baseline Term</span>
      <el-select v-model="termSelection" v-if="!showOnlySchoolSelector && !hideTerms" filterable collapse-tags
        placeholder="Select Term" @change="returnSelection" class="full">
        <el-option v-for="item in terms" :key="item.term" :label="item.term === 'CURRENT' ? 'CURRENT TERM' : item.term"
          :value="item.term"></el-option>
      </el-select>
    </div>
    <div style="width: 12%; display: inline-block" class="mobileFullRow"
      v-if="showSchoolAddress || (!showOnlySchoolSelector && !hideTerms)">
      <span class="formLabel">Show Term</span>
      <el-select v-model="termSelection" v-if="!showOnlySchoolSelector && !hideTerms" filterable class="full"
        collapse-tags placeholder="Select Term" @change="returnSelection">
        <el-option v-for="item in terms" :key="item.term" :label="item.term === 'CURRENT' ? 'CURRENT TERM' : item.term"
          :value="item.term"></el-option>
      </el-select>
    </div>

    <el-radio-group v-model="typeSelection" @change="returnSelection" class="greyBg" v-if="!showOnlySchoolSelector"
      style="margin-top: -1px; margin-right: 5px; margin-left: 5px">
      <el-radio-button label="all">ALL USERS</el-radio-button>
      <el-radio-button label="parent">PARENTS ONLY</el-radio-button>
      <el-radio-button label="staff">STAFF ONLY</el-radio-button>
    </el-radio-group>
    <el-button @click="returnSelection" type="warning" size="large">
      Run</el-button>
  </el-row>
</template>

<script lang="js">
import ApiService from "@/services/ApiService";
export default {
  data() {
    return {
      schools: [],
      groups: [],
      councils: [],
      schoolSelection: [],
      typeSelection: "all",
      termSelection: "CURRENT",
      schoolAddressId: 0,
      dateRange: [],
      terms: [],
      schoolAddresses: [{ id: 0, name: "All Addresses" }],
      showSchoolAddress: false,
      filterGroups: []
    };
  },
  props: {
    func: Function,
    showOnlySchoolSelector: Boolean,
    hideTerms: Boolean,
    showDatePicker: Boolean,
    hideAddress: Boolean,
    updateOnChange: Boolean,
    showBaseline: Boolean,
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
    orgId: function () {
      return this.$store.state.orgId;
    },
  },
  methods: {
    goto(page) {
      this.$router.push({ name: page });
    },
    updateSelection() {
      if (this.accType === "SUPERADMIN") {
        if (this.updateOnChange) {
          this.returnSelection();
        }
        return;
      } else {
        this.returnSelection();
      }
    },
    returnSelection() {
      if (
        (this.schoolSelection.length === 1 &&
          !isNaN(this.schoolSelection[0])) ||
        this.accType === "SCHOOL_ADMIN"
      ) {
        if (!this.hideAddress) {
          this.showSchoolAddress = true;
          if (this.accType === "SCHOOL_ADMIN") {
            this.getOrgAddresses(this.orgId);
          } else if (this.accType === 'SUPERADMIN' || this.accType === 'MULTI_SCHOOL_ADMIN') {
            this.getOrgAddresses(this.schoolSelection[0]);
          }
        }
      } else {
        this.showSchoolAddress = false;
      }
      this.$emit("return-selection",
        {
          schoolIds: this.schoolSelection,
          school_ids: this.schoolSelection,
          organization_address_id:
            this.showSchoolAddress && this.schoolAddressId
              ? this.schoolAddressId
              : null,
          type: this.typeSelection,
          term: this.termSelection,
          range: this.dateRange,
        }
      );
      //   return ;
    },
    // setAccountType() {
    //   const adminRoles = this.$store.state.user.admin_roles;
    //   if (adminRoles.length > 0) {
    //     this.accType = adminRoles[0].slug;
    //   }

    // },
    getOrgAddresses(schoolId) {
      ApiService.generalApi.getOrgAddresses(schoolId).then((resp) => {
        this.schoolAddresses = resp.data;
        this.schoolAddresses.unshift({ id: 0, name: "All Addresses" });
      });
    },
    submit() {
      this.returnSelection();
    },
  },
  mounted() {
    if (this.accType != "SUPERADMIN") {
      setTimeout(() => {
        this.returnSelection();
      }, 500)
      // this.showSchoolAddress = true;
      // this.getOrgAddresses(adminRoles[0].admin_organization_id);
    }
    ApiService.generalApi
      .getOrgsGroupsFiltering()
      .then((response) => {
        const filterGroups = [];
        this.schools = response.data.schools;
        const groups = response.data.groups.map((itm) => {
          return {
            id: 'group_' + itm.id,
            name: itm.name
          }
        });
        const councils = response.data.councils.map((itm) => {
          return {
            id: 'council_' + itm.id,
            name: itm.name
          }
        });

        if (this.schools.length > 0) {
          filterGroups.push({
            label: 'Schools only',
            options: this.schools
          });
        }

        if (groups.length > 0) {
          filterGroups.push({
            label: 'GROUPS only',
            options: groups
          });
        }
        if (councils.length > 0) {
          filterGroups.push({
            label: 'Councils',
            options: councils
          });
        }
        this.filterGroups = filterGroups;
      });
    ApiService.generalApi.getTerms().then((resp) => {
      this.terms = resp.data;
      if (this.accType != "SUPERADMIN") {
        this.returnSelection();
      }
    });
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.block {
  margin-bottom: 8px;
}

.circularButton {
  width: 50px;
  height: 50px;
}

.half {
  width: 50%;
}

.full {
  width: 100%;
}
</style>
<style>
.filteringMain .el-radio-button__inner {
  font-size: 11px;
  padding: 13px 9px !important;
}

.filteringMain .el-input {
  font-size: 12px;
}

span.formLabel {
  position: absolute;
  top: -14px;
  font-size: 11px;
  padding-left: 4px;
}
</style>
